import React, { SetStateAction, useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import getConfig from 'next/config';
import useWindowWidth from 'utils/useWindowWidth';
import { configuratorContext } from 'context/ConfiguratorContext';
import Search from '../Search';
import AiToolkitLink from '../AiToolkitLink/AiToolkitLink';
import styles from './NavItems.module.css';

type NavItemsProps = {
  type: 'mobile' | 'desktop';
  unanswered: number | null;
  setShowSearch: (show: SetStateAction<boolean>) => void;
  showSearch?: boolean;
};

const NavItems = ({ type, unanswered, setShowSearch, showSearch }: NavItemsProps) => {
  const navigationType =
    type === 'mobile' ? styles.nav_list__mobile : styles.nav_list__desktop;
  const windowWidth = useWindowWidth();

  const { azFromConfigurator } = useContext(configuratorContext);

  const showAiToolkit = azFromConfigurator?.otvety_ai_toolkit?.groupName === 'target';

  const {
    publicRuntimeConfig: { AI_TOOLKIT_URL },
  } = getConfig();

  return (
    <ul className={`${styles.nav_list} ${navigationType}`}>
      <li className={styles.nav_list__item}>
        <Link href="/unanswered">
          <a className={styles.nav_list__link} data-qa-marker="need_answer_btn">
            Нужен ответ
            {unanswered ? (
              <span className={`${styles.counter} ${styles.bounce_in}`}>
                {unanswered}
              </span>
            ) : null}
          </a>
        </Link>
      </li>
      <li className={styles.nav_list__item}>
        <a
          href="https://uchi.ru/"
          className={styles.nav_list__link}
          data-qa-marker="uchi_ru_btn"
        >
          Учи.ру
        </a>
      </li>
      {showAiToolkit && (
        <li className={styles.nav_list__item}>
          <AiToolkitLink
            className={styles.nav_list__link}
            link={AI_TOOLKIT_URL}
            event_name="otvety-header-ai-toolkit-click"
          />
        </li>
      )}
      {showSearch && windowWidth < 1024 ? (
        <Search setShowSearch={setShowSearch} />
      ) : (
        <span
          onClick={() => setShowSearch(true)}
          className={`${styles.nav_list__item} ${styles.nav_list__link} ${styles.nav_list__df}`}
        >
          <Image
            src="https://static.uchi.ru/files/otvety/search.svg"
            width={20}
            height={20}
            alt="search"
          />
          Поиск
        </span>
      )}
    </ul>
  );
};

export default NavItems;
